import { gql } from "apollo-boost";

export const CREATE_SHIPPING_OPTION = gql`
    mutation createShippingOption($input: CreateShippingOptionInput!) {
        createShippingOption(input: $input) {
            id
            name
        }
    }
`;
